export default __webpack_public_path__ + "static/media/camera.eaf246ac.svg";